import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CardBody = ({muted, children, className}) => {
  const cardClass = classNames('card-block', className, {
    'bg-light': muted
  });
  return (
    <div className={cardClass}>
      {children}
    </div>
  );
};

CardBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ]),
  muted: PropTypes.bool,
  className: PropTypes.string
};

export default CardBody;
